<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="w-full">
                <div class="w-full grid-view-item">
                    <vx-card class="grid-view-item mb-base">
                        <div>
                          <label>{{$t('Labels.Client')}}</label>
                          <v-select :options="clients" v-model="license.client"/>
                        </div>
                        <div class="mt-2 inline-block">
                          <label>{{$t('Labels.Start')}}</label>
                          <datepicker :value="license.start" name="start"></datepicker>
                        </div>
                        <div class="mt-2 ml-2 inline-block">
                          <label>{{$t('Labels.Expire')}}</label>
                          <datepicker :value="license.expire" name="expire"></datepicker>
                        </div>
                        <div class="text-right">
                          <vs-button @click="requestPassword()" class="bg-primary mt-4" type="filled">{{$t("Labels.Save")}}</vs-button>
                        </div>
                    </vx-card>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPass, globalPassActions} from '@/globalPass'

export default {
  components: {
    vSelect,
    Datepicker
  },

  data () {
    return {
      clients: [],
      uuid: this.$route.params.uuid,
      license:{
        client: {},
        start: new Date(2016, 9,  16),
        expire: new Date(2016, 9,  16)
      }
    }
  },

  methods: {
    getClients () {
      this.clients = [
        { label:'Cliente 1', value:'1'},
        { label:'Cliente 2', value:'2'},
        { label:'Cliente 3', value:'3'}
      ]

                        
    },
    requestPassword () {
      globalPassActions.show()
    },
    async update () {
      const params = {
        url: `licenses/${this.uuid}`,
        method: 'PUT',
        params: this.data
      }
      await request(params).then(response => {
        this.data = response.data.data
      })       
    }
  },
  created () {
    this.getClients()
  },
  computed: {
    isVisiblePassword () {
      return globalPass.active
    } 
  },
  watch:{
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible == false) this.update()
    }
  }
}
</script>
